/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramUsersControllerGetMeQueryResponse,
  TelegramUsersControllerGetMe401,
} from '../../types/TelegramUsersControllerGetMe.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramUsersGetMe } from '../../methods/telegramUsersGetMe.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramUsersGetMeQueryKey = () => [{ url: '/api/telegram/users/me' }] as const;

export type TelegramUsersGetMeQueryKey = ReturnType<typeof telegramUsersGetMeQueryKey>;

export function telegramUsersGetMeQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = telegramUsersGetMeQueryKey();
  return queryOptions<
    TelegramUsersControllerGetMeQueryResponse,
    ResponseErrorConfig<TelegramUsersControllerGetMe401>,
    TelegramUsersControllerGetMeQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramUsersGetMe(config);
    },
  });
}

/**
 * {@link /api/telegram/users/me}
 */
export function useTelegramUsersGetMe<
  TData = TelegramUsersControllerGetMeQueryResponse,
  TQueryData = TelegramUsersControllerGetMeQueryResponse,
  TQueryKey extends QueryKey = TelegramUsersGetMeQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramUsersControllerGetMeQueryResponse,
        ResponseErrorConfig<TelegramUsersControllerGetMe401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramUsersGetMeQueryKey();

  const query = useQuery(
    {
      ...telegramUsersGetMeQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramUsersControllerGetMe401>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
